module.exports = "<li v-el:v v-if=\"loading\"><slot></slot></li>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Option.vue
// module id = 155
// module chunks = 0